import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/cn';
import { EMPLOYEE_NAV } from '@/app/navigation';
import { useVisibleNav } from '@/access/useVisibleNav';

/**
 * ניווט ראשי: גובה 72, פחם, פעיל ב olive, תג ספירה olive.
 * פריט של מודול כבוי לא מוצג (מסמך התכנון, סעיף 8.3).
 */
export function BottomNav({ counts = {} }: { counts?: Record<string, number> }) {
  const items = useVisibleNav(EMPLOYEE_NAV);

  return (
    <nav
      aria-label="ניווט ראשי"
      className="sticky bottom-0 z-20 grid h-18 border-t border-charcoal bg-charcoal pb-[env(safe-area-inset-bottom)]"
      style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}
    >
      {items.map(({ to, label, icon: Icon }) => {
        const count = counts[to] ?? 0;
        return (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              cn(
                'relative flex flex-col items-center justify-center gap-1 text-label no-underline',
                isActive ? 'text-olive' : 'text-on-charcoal/80',
              )
            }
          >
            <Icon size={24} strokeWidth={1.75} aria-hidden="true" />
            <span>{label}</span>
            {count > 0 && (
              <span
                className="absolute top-2 end-1/4 min-w-5 rounded-pill bg-olive px-1 text-label font-medium text-on-olive tabular"
                aria-label={`${count} חדשים`}
              >
                {count > 99 ? '99+' : count}
              </span>
            )}
          </NavLink>
        );
      })}
    </nav>
  );
}
